// const base_endpoint = window.location.hostname == 'localhost' ? "http://127.0.0.1:8000/api" : "https://admingame.centrosdeexperiencia.com/api"; // Produccion
const base_endpoint = "https://admingame.centrosdeexperiencia.com/api"; // Produccion
export default base_endpoint;